module.exports = __webpack_public_path__ + "img/invk-checkpoint-model-selector.4b264c9a.png";